import CountDown from "../../uiComponents/CountDown";
import React from "react";

export default (props) => {
    let timeout = window.AppConf.scanCustomerCardTimeout;
    if(timeout === 0){
        return <div/>;
    }
    return <CountDown
        style={{
            display: 'inline-block',
            color: '#7f7f7f',
            backgroundColor: '#f7f7f7',
            borderRadius: '50%',
            width: '14.29rem',
            height: '3.57rem',
            fontSize: '2.29rem',
            fontWeight: 'bold',
            lineHeight: 1.5
        }}
        onDone={e => {
            props.setDefaultCustomer();
        }}
        timeInSeconds={timeout}
    />
}